import { createFileRoute } from "@tanstack/react-router";
import { KpisCurrentPage } from "../../../../pages/kpis/current/page";

export const Route = createFileRoute("/_pathlessLayout/kpis/current")({
    component: KpisCurrentPage,
});
